import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { InvoiceEntity } from '../../../apis/dealsAPI'

export const INVOICES_QUERY_KEY_ROOT = ['deals', 'invoices'] as const

export function invoicesQueryKey(dealId: string): readonly unknown[] {
  return [...INVOICES_QUERY_KEY_ROOT, 'list', dealId]
}

export function useInvoicesQuery(
  dealId: string | null,
  initialData?: InvoiceEntity[],
): UseQueryResult<InvoiceEntity[]> {
  return useQuery<InvoiceEntity[]>(
    invoicesQueryKey(dealId ?? ''),
    () => dealsAPI.listInvoices(dealId as string),
    {
      enabled: dealId !== null && dealId !== '',
      initialData,
      keepPreviousData: true,
    },
  )
}
